var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsMIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2281",
    "data-name": "Group 2281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.764,
    height: 48.336,
    viewBox: "0 0 65.764 48.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 65.764,
    height: 48.336,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M672.705,249.081c-.569.331-1.159.641-1.758.942v10.251c.589-.3,1.169-.6,1.729-.928,6.356-3.694,9.537-8.527,9.551-13.368l.029-10.265c-.014,4.841-3.2,9.675-9.551,13.368",
    transform: "translate(-616.492 -216.582)",
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M9.731,246.958c-6.48-3.741-9.716-8.652-9.7-13.556L0,243.667c-.014,4.9,3.222,9.815,9.7,13.556,6.116,3.531,14.019,5.382,22,5.557V252.514c-7.975-.18-15.867-2.03-21.975-5.557",
    transform: "translate(0.001 -214.459)",
    fill: "#433473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M390.656,416.646v10.266c8.093.178,16.268-1.364,22.749-4.63V412.032c-6.484,3.259-14.659,4.8-22.749,4.614",
    transform: "translate(-358.95 -378.591)",
    fill: "#d1365a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M686.281,66.254l-.126-.071,0,0-.014-.008.151.085-.009,0",
    transform: "translate(-630.45 -60.802)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M428.3,50.822c12.794,7.386,12.859,19.539.152,26.924l-.182.1-.173.1q-.2.112-.4.223c-.143.078-.282.153-.423.227l-.153.08q-.2.105-.41.209l-21.575-14.4L425.2,49.244q.865.386,1.681.806l.163.084.165.086.111.059.232.124.174.095.178.1.181.1.216.123",
    transform: "translate(-372.253 -45.247)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M677.953,61.716l.019.01-.065-.034.046.024",
    transform: "translate(-622.887 -56.685)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M686.309,66.27l0,0h0l0,0",
    transform: "translate(-630.603 -60.89)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M390.656,253.573l1.175-19.023,21.574,14.4c-6.482,3.261-14.657,4.8-22.749,4.621",
    transform: "translate(-358.95 -215.514)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M679.274,62.425l-.125-.07-.053-.029-.139-.076-.035-.019-.172-.092-.041-.022q.294.157.583.318l-.018-.01",
    transform: "translate(-623.625 -57.075)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M672.671,58.973l.065.035c-.151-.08-.3-.159-.457-.237l.064.032.06.031.1.053.077.04.088.046",
    transform: "translate(-617.716 -54.001)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M688.582,67.554l-.172-.1h0l.174.1",
    transform: "translate(-632.536 -61.979)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M32.6,38.466q-1.309-.028-2.6-.118a46.219,46.219,0,0,1-18.968-5.206l-.419-.238C-2.182,25.52-2.25,13.366,10.457,5.981,22.184-.834,40.959-1.36,53.839,4.4L33.774,19.443Z",
    transform: "translate(-0.892 -0.406)",
    fill: "#644daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M670.948,409.648h0c.137-.069.275-.138.41-.208q-.2.105-.409.209",
    transform: "translate(-616.492 -376.208)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M143.743,408.544a45.88,45.88,0,0,1-18.861-5.2,46.065,46.065,0,0,0,18.861,5.2",
    transform: "translate(-114.746 -370.61)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M180.466,4c-12.275-5.492-29.9-5.272-41.684.659C151-1.513,169.257-1.551,181.619,4.539q-.566-.278-1.154-.542",
    transform: "translate(-127.518 0)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M668.691,56.96l.291.147-.291-.147",
    transform: "translate(-614.419 -52.337)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M138.393,57.376l.032-.016-.032.016",
    transform: "translate(-127.161 -52.705)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M131.882,57.832q.262-.139.528-.273-.266.134-.528.273",
    transform: "translate(-121.178 -52.887)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M129.226,61.034l.216-.116-.216.116",
    transform: "translate(-118.738 -55.974)",
    fill: "#ff597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M124.884,62.54c.116-.064.235-.127.352-.191-.118.063-.236.126-.352.191",
    transform: "translate(-114.748 -57.289)",
    fill: "#ff597f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsMIcon1);
export default __webpack_public_path__ + "static/media/maths-m-icon-1.7928b564806cfab80bb8d16ab21b5d43.svg";
export { ForwardRef as ReactComponent };